import getInvestmentAmountForProjectTier from "./getInvestmentAmountForProjectTier";
import type { Column, Project, Investment, GetTierTitle } from "../types";

const getInvestmentClassColumns = (project: Project, getTierName: GetTierTitle): Column[] => {
  const { tiers: projectTiers } = project;

  const columns = projectTiers.map((tier) => {
    const { name: tierId } = tier;

    const title = getTierName(tier);

    const value = (investment: Investment): string => {
      const amount = getInvestmentAmountForProjectTier(tierId, investment);

      return amount;
    };

    return {
      value,
      title,
    };
  });

  return columns;
};

export default getInvestmentClassColumns;
